import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from '../../../../../autentication/Auth';
import { EventTypes } from '../../../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../../../utils/AppEventDispatcher';
import { Util } from '../../../../../utils/util';
import { PixKeyType } from '../../../models/key-type.enum';
import { PixReceipt } from '../../../models/receipt.model';
import { PixPaymentKeyService } from '../../payment-key.service';
import * as moment from 'moment';

@Component({
	selector: 'app-pix-payment-key-favored-create-resume-final',
	templateUrl: './resume-final.component.html',
	styleUrls: ['./resume-final.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixPaymentKeyFavoredCreateResumeFinalComponent implements OnInit {
	public receipt: PixReceipt;
	public meuNome: string;
	public title: string;
	public subtitle: string;
	public today: string;

	constructor(
		private router: Router,
		private pixPaymentKeyService: PixPaymentKeyService,
	) { }

	get favoredBankName(): string {
		return this.receipt.iSPBNome ? Util.camelCaseText(this.receipt.iSPBNome) : '';
	}

	get favoredName(): string {
		return  this.receipt.nome ? Util.camelCaseText(this.receipt.nome) : '';
	}

	get isScheduled(): boolean{
		if (!this.receipt || !this.receipt.dataTransacao) {
			return false;
		}

		return moment(this.receipt.dataTransacao).isSame(moment(), 'day') ? false : true;
	}


	get meuCpfCnpj(){
		return Auth.getInstance().getUser().cpfCnpj ? Auth.getInstance().getUser().cpfCnpj : Auth.getInstance().getUser().cpf;
	}
	

	ngOnInit(): void {
		this.receipt = this.pixPaymentKeyService.getSelectedPixReceipt();
		this.meuNome = Auth.getInstance().getUser().name ? Auth.getInstance().getUser().name : Util.camelCaseText(Auth.getInstance().getUser().loggedUserName);
		this.invalidParams() ? this.goBack() : '';
		this.title = this.receipt.agendado ? 'Comprovante de agendamento' : 'Comprovante de transferência';
	}

	invalidParams(): boolean {
		return this.receipt === undefined ||
			this.receipt.valor === undefined ||
			this.receipt.nome === undefined;
	}

	get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	getCpfCnpj(cpfCnpj: string) {
		return Util.maskCpfCnpjPix(cpfCnpj);
	}

	goBack = () => this.router.navigate(['pix/pagamento/']);
	emitNew = () => this.router.navigate(['pix/pagamento/']);
	emitPrint = () => window.print();

	handleError(error) {
		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/payment-key/favored-create/resume-final/resume-final.component.ts